// Reclasificación read-only de estadio_vfp en runtime.
//
// HISTÓRICO (mayo 2026): VFP solía no distinguir FPC vs FRC y se reclasificaba
// con la regla 24-semanas. Desde el sync VFP completo, VFP ya marca FRC
// directamente (planmanejo.dbf tiene FRC con sus propios ciclos), por lo que
// la reclasificación dejó de ser necesaria y producía diferencias contra VFP
// (bloques que VFP tiene como FPC, ERP los pintaba como FRC).
//
// Decisión 2026-05-23: devolver siempre el código tal cual viene de VFP.
// La función se mantiene para no romper imports existentes.

export interface BloqueConFechas {
  estadio_vfp?: string | null;
  fecha_segunda?: string | null;
}

/**
 * Devuelve el estadio del bloque tal cual VFP lo guarda.
 * (La regla 24-semanas se desactivó: VFP ya distingue FPC vs FRC.)
 */
export function reclasificarEstadio(bloque: BloqueConFechas, _hoy: Date = new Date()): string {
  return String(bloque.estadio_vfp ?? '').trim().toUpperCase();
}
